import React from "react";
import style from "./index.module.scss";

export default function RollCall() {
    return <div className={style.root}>RollCall</div>;
}
